function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextPostPreviewImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a183b"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.365 17.201 1.966 2.607h-2.624l-.654-.867-1.064 1.411.799 1.061h6.881l-4.242-5.625-1.062 1.413ZM14.954 13.509l-1.872-2.482h-2.126l3.998 5.303 5.211-6.909h2.626l-7.837 10.387L7.119 9.425l7.377-.004 1.118 1.482 1.064-1.412-1.264-1.678-11.637.002 11.177 14.814L26.137 7.813h-6.889l-4.294 5.696Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextPostPreviewImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TextPostPreviewImage.20d6803e2883259c616de8be2bfa001e.svg";